import { TProductReviewsSummary } from '@/shared/types/product-types'

import { CatalogProductsData } from '../schema/catalog.schema'

type ApiCatalogReviewRating = {
	code?: string | number
	rating?: string | number
	count?: string | number
}

type ApiCatalogReviewRatings = ApiCatalogReviewRating[] | { data?: ApiCatalogReviewRating[] }

const toNumber = (value: string | number | undefined) => Number(value) || 0
const getReviewItems = (payload: ApiCatalogReviewRatings = {}) =>
	Array.isArray(payload) ? payload : payload.data ?? []

export const getCatalogReviewCodes = (items: CatalogProductsData['ITEMS']) =>
	Array.from(new Set(items.map(item => Number(item.KOD)).filter(Number.isFinite)))

const mapCatalogReviewRatings = (payload: ApiCatalogReviewRatings = {}) =>
	getReviewItems(payload).reduce<Record<string, TProductReviewsSummary>>((result, item) => {
		if (!item.code) return result

		result[String(item.code)] = {
			RATING: toNumber(item.rating),
			COUNT: toNumber(item.count)
		}

		return result
	}, {})

export const mapCatalogProductsWithReviews = (
	data: CatalogProductsData,
	reviewsPayload?: ApiCatalogReviewRatings
): CatalogProductsData => {
	const ratings = mapCatalogReviewRatings(reviewsPayload)

	return {
		...data,
		ITEMS: data.ITEMS.map(item => {
			const summary = ratings[String(item.KOD)]
			return summary ? { ...item, REVIEWS_SUMMARY: summary } : item
		})
	}
}
